/** 
 * @module ref/autocdm1 核心功能模块
*/

import api from "@/http/api";
import { sortTasks, customCompInfos, buildTasksTree as btt } from "@/ref/custom.js";
import { compression } from "@/ref/autocdm/threejsUtils.js";


/** 
 * @type {componentUtils}
 * @description autocdm生成构件和模型的api
 */
let componentUtils = require("@/ref/autocdm/componentUtils");
let cu = componentUtils.componentUtils;

/**
 *从autocdm取模型数据和属性数据，并处理出来。
 *
 * @param {string} projectid 项目id/工程id
 * @param {string} projecttype 项目类型。比如house,road
 * @return {promise} 
 */
async function getAutoCDMModel(projectid, projecttype) {
    let blob;
    try {
        blob = await api.autoCDM.getAutoCDMData({ projectid: projectid, projecttype: projecttype });//1426022433505886210 1427830427927404545 init_demo1_Project_admin 1424613370675007489  
    } catch (e) {
        return Promise.reject(e);
    };
    let getDataPromise = new Promise(function (resolve, reject) {
        try {
            if (projecttype == "house") {
                compression.inflate(blob, function (u8array) {
                    compression.u8arrayToStr(u8array, "utf-8", function (jsonstr) {

                        let data = JSON.parse(jsonstr);
                        //componentUtils解释生成THREE.Group            
                        cu.buildComponent(data, null, null, null, function (threeGroup) {
                            let compInfos = customCompInfos(data, projecttype);
                            resolve({ model: threeGroup, compInfos: compInfos });
                        });
                        //缺省
                        resolve({ model: null, compInfos: {} });

                    });
                });
            } else if (projecttype == "Eroad") {
                //componentUtils解释生成THREE.Group            
                cu.buildComponent(null, blob.data, null, null, function (threeGroup) {
                    let compInfos = customCompInfos(threeGroup, projecttype);
                    resolve({ model: threeGroup, compInfos: compInfos });
                });
                //缺省
                resolve({ model: null, compInfos: {} });
            } else if (projecttype == "Ebridge") {
                //componentUtils解释生成THREE.Group            
                cu.buildComponent(null, null, null, blob.data, function (threeGroup) {
                    let compInfos = customCompInfos(threeGroup, projecttype);
                    resolve({ model: threeGroup, compInfos: compInfos });
                });
                //缺省
                resolve({ model: null, compInfos: {} });
            } else if (projecttype == "Etunnel") {
                //componentUtils解释生成THREE.Group            
                cu.buildComponent(null, null, blob.data, null, function (threeGroup) {
                    let compInfos = customCompInfos(threeGroup, projecttype);
                    resolve({ model: threeGroup, compInfos: compInfos });
                });
                //缺省
                resolve({ model: null, compInfos: {} });
            } else if (projecttype == "imported") {
                //componentUtils解释生成THREE.Group       
                sessionStorage.setItem("userid", "abc");
                cu.buildModel(blob.data, function (e) {
                    console.log(e);
                }, function (threeGroup) {
                    if (blob.data.isIfc) {
                        threeGroup.children[0].mid = blob.data.idList[0];
                    }
                    let compInfos = customCompInfos(blob.data, projecttype);
                    resolve({ model: threeGroup, compInfos: compInfos });
                });
            } else if (projecttype == "road") {
                resolve({ model: null, compInfos: {} });
            } else {
                resolve({ model: null, compInfos: {} });
            }
        } catch (e) {
            reject(e);
        }
    });
    let threeGroup = await getDataPromise;
    return threeGroup;
};


/**
 *
 *取项目/工程 对应的甘特图任务数据
 * @param {string} projectid 项目id/工程id
 * @return {promise} 
 */
async function getGanttTasks(projectid) {
    let res = await api.autoCDM.findByProjectId(projectid);
    let ret = res.data;
    return ret;
};


/**
 *取指定用户的所有项目/工程
 *
 * @param {string} accountid
 * @return {promise} 
 */
async function getAutoCDMProjects(accountid) {
    let values = await api.autoCDM.getAutoCDMProjects(accountid);
    let ret;
    if (values && values.success) {
        ret = values.data.data;
    }
    return ret;
};

//--------------------play task------------------------------------------------
function PlayTaskClazz(hasGantt) { this.hasGantt = hasGantt; };
PlayTaskClazz.prototype.doTask = function () {
    if (this.hasGantt) {
        gantt.unselectTask();
        gantt.selectTask(this.id);
        gantt.showTask(this.id);
    };
    let vs = this.viewers;
    let ms = this.meshsArray;
    for (let i = 0; i < vs.length; i++) {
        let viewer = vs[i];
        let meshs = ms[i];
        meshs.forEach(function (m) {
            m.traverse(function (mm) {
                mm.visible = true;
            });
            viewer.doOneRender();
        });
    }
};
/**
 *
 *根据ganttTasks，为虚拟建造build出相应的tasks，只对【构件任务】
 * @param {viewer} viewer
 * @param {array} ganttTasks
 * @param {object} meshsMap
 * @param {string} [sortTaskField="start_date"] 任务的属性，指定来排序的，缺省start_date
 * @return {array} PlayTaskClazz Array
 */
function buildTasks(viewer, ganttTasks, meshsMap, hasGantt = true, sortTaskField = "start_date") {
    let tasks = [];
    let datas = ganttTasks.data;
    datas = datas.slice();
    sortTasks(datas, sortTaskField);
    datas.forEach(function (tk) {
        if (tk.type == "compTask") {//只对构件任务
            let task = new PlayTaskClazz(hasGantt);
            tasks.push(task);
            let meshs = [];
            task.meshsArray = []; task.meshsArray.push(meshs);
            task.viewers = [viewer];
            task.id = tk.id;

            let b = tk.bindComps; //every task
            if (b) {
                if (!(b instanceof Array)) {
                    try { b = JSON.parse(b); } catch (e) { b = [] }
                }
            } else b = [];
            b.forEach(function (key) {
                let mesh = meshsMap[key];
                if (mesh) meshs.push(mesh);
            });
        } else {
            if (gantt.hasChild(tk.id))
                gantt.open(tk.id);
        }
    });
    return tasks;
};


/**
 *将task1 合并到 task0中。用于对比模拟建造中，将两个建造任务合并成一个，再给play执行。
 *
 * @export
 * @param {array} tasks0 PlayTaskClazz
 * @param {array} tasks1 PlayTaskClazz
 */
export function mergeTasks(tasks0, tasks1) {
    let len = tasks0.length; let len1 = tasks1.length;
    if (len == len1 && len > 0) {
        for (let i = 0; i < len; i++) {
            let task0 = tasks0[i]; let task1 = tasks1[i];
            let ma0 = task0.meshsArray;
            let ma1 = task1.meshsArray;
            let vs0 = task0.viewers;
            let vs1 = task1.viewers;
            task0.meshsArray = ma0.concat(ma1); task0.viewers = vs0.concat(vs1);
        }
    }
};
let taskUtils = {
    fromServer: function (task) {
        let bindComps = task.bindComps;
        if (bindComps instanceof Array) { } else {
            try {
                bindComps = JSON.parse(bindComps);
            } catch (e) { bindComps = []; };
        }
        task.bindComps = bindComps;
        task.start_date = new Date(task.start_date);
        task.actual_start_date = new Date(task.actual_start_date);
        task.actual_end_date = new Date(task.actual_end_date);
        task.open = true;//默认展开节点     
    },
    toServer: function (task) {
        task.id = task.id + "";
        if (task.bindComps) {
            let bindComps = task.bindComps.substr ? task.bindComps : JSON.stringify(task.bindComps);
            task.bindComps = bindComps;
        }
    }
};
/**
 *
 *根据构件和构件属性，生成任务树
 * @export
 * @param {array} Comps 构件数据
 * @param {object} compInfos 构件属性数据，相关于map数据结构
 * @return {array}  [id:"",label:"",children:[]]
 */
function buildTasksTree(Comps, compInfos) {
    return btt(Comps, compInfos);
};


/**
 *
 *从数组[root]中取到root和children的id
 * @param {array} roots
 * @return {array} 
 */
function getChild(roots) {
    let ret = [];
    let len = roots.length;
    for (let i = 0; i < len; i++) {
        let root = roots[i];
        let children = root.children;
        if (children instanceof Array && children.length > 0) {
            let rett = getChild(children);
            ret = ret.concat(rett);
        } else {
            ret.push(root.id);
        }
    }
    return ret;
};
/**
 *
 *根据甘特图所有任务的bindComps，算出剩下未被绑定的构件array,剩下没有被选的构件
 * @param {array} ganttdatas 甘特图任务数据
 * @param {array} allComps 所有构件mesh
 * @return {array} 
 */
function getRemainComps(ganttdatas, allComps) {
    let ret = allComps.slice(); //复制
    let map = {};
    ret.forEach(function (c) {
        map[c.key] = c;
    });
    let data = ganttdatas.data;
    let size = data.length;
    for (let i = 0; i < size; i++) {
        let task = ganttdatas.data[i];
        //if (task.id == id) continue;
        let bindcomps = task.bindComps;
        if (!bindcomps.forEach) {
            let a; try { a = JSON.parse(bindcomps); } catch (e) { }
            if (a) { task.bindComps = a; bindcomps = a; }
        }
        bindcomps.forEach(function (key) {
            delete map[key];
        });
    }
    ret = [];
    for (let k in map) {
        ret.push(map[k]);
    }
    return ret;
};
//-----------------------------------------------------------------------------------------------------------
/**
 *自动生成计划任务数据
 *
 * @param {array} comps 构件数据  store.tbim.meshs
 * @param {object} compInfos 属性map
 * @param {string} projectid 项目/工程id
 * @return {object}  ganttTask
 */
function autoBuildTasks(comps, compInfos, projectid) {
    let array = [];
    let treeNodes = buildTasksTree(comps, compInfos);
    handle(array, treeNodes, null, projectid);
    let ret = {
        data: array,
        links: []
    };
    return ret;
};
function handle(array, treeNodes, parent, projectid) {
    let wbs = 0;
    let len = treeNodes.length;
    for (let i = 0; i < len; i++) {
        wbs++;
        let node = treeNodes[i];
        if (parent) {
            node.parent = parent.realid ? parent.realid : "0";
            let w = parent.wbs == "" ? "" : parent.wbs + ".";
            node.wbs = w + wbs;
        } else {
            node.parent = "0";
            node.wbs = "";
        }
        //任务绑定构件id
        let b = [];
        let hasComps = node.id && node.id.length > 17;//如果当前id的len大于17,就认为是构件
        if (hasComps) b = [node.id];
        //新任务包括 wbs,id,type,text,progress,duration,start_date,parent,bindComps字段
        let date = new Date().toLocaleDateString();
        let d = new Date(date);
        let ed = new Date(date);
        ed = DateAdd("d", 1, ed);
        if (parent) array.push({ wbs: node.wbs, id: node.realid, type: hasComps ? gantt.config.types.compTask : gantt.config.types.task, text: node.label, progress: 0, duration: 1, start_date: d, actual_start_date: d, actual_end_date: ed, parent: node.parent, projectid: projectid, bindComps: b, open: true });
        let children = node.children;
        if (children && children.length > 0) {
            handle(array, children, node, projectid);
        }
    };
};
function ramdomID() {
    let a = Math.random() * 10000000000000 + ""; a = a.substr(0, 5);
    let b = Math.random() * 10000000000000 + ""; b = b.substr(0, 5);
    let ret = a + b;
    return ret;
};
/*
        *---------------Begin  DateAdd(interval,number,date)  -----------------
        *  DateAdd(interval,number,date)
        *  功能:实现JavaScript的时间新增功能.
        *  参数:interval,字符串，表示要添加的类型.
        *  参数:number,数字，表示要添加的数量.
        *  参数:date,时间对象.
        *  返回:新的时间对象.
        *  var  now  =  new  Date();
        *  var  newDate  =  DateAdd("d",-10,now);//当前天数减少10天的时间
        *---------------End  DateAdd(interval,number,date)  -----------------
        */
function DateAdd(interval, number, date) {

    switch (interval) {
        case "y": {
            date.setFullYear(date.getFullYear() + number);
            return date;
            break;
        }
        case "q": {
            date.setMonth(date.getMonth() + number * 3);
            return date;
            break;
        }
        case "m": {
            date.setMonth(date.getMonth() + number);
            return date;
            break;
        }
        case "w": {
            date.setDate(date.getDate() + number * 7);
            return date;
            break;
        }
        case "d": {
            date.setDate(date.getDate() + number);
            return date;
            break;
        }
        case "h": {
            date.setHours(date.getHours() + number);
            return date;
            break;
        }
        case "m": {
            date.setMinutes(date.getMinutes() + number);
            return date;
            break;
        }
        case "s": {
            date.setSeconds(date.getSeconds() + number);
            return date;
            break;
        }
        default: {
            date.setDate(date.getDate() + number);
            return date;
            break;
        }
    }
};

/**
 *新增构件任务时，将构件任务下挂到指定的任务节点下
 *
 * @param {string} seledTaskid 指定的任务节点
 * @param {array} compIds mesh id的数组
 * @param {object} meshsMap 
 */
function appendCompTasks(seledTaskid, compIds, meshsMap) {
    //改成批量save
    let children = gantt.getChildren(seledTaskid); //parent有多少个child
    let addIndex = children.length; //为做index插入后面
    let date = new Date().toLocaleDateString();
    let startdate = new Date(date);
    let parentid = seledTaskid + "";

    let len = compIds.length;
    for (let i = 0; i < len; i++) {
        let compId = compIds[i];
        let comp = meshsMap[compId];

        let bindComps = [compId]; bindComps = JSON.stringify(bindComps);
        let isEnd = (i == (len - 1));
        let taskId = gantt.addTask(
            {
                text: comp.label,
                start_date: startdate,
                duration: 1,
                type: gantt.config.types.compTask,
                bindComps: bindComps,
                isNeedSplit: true,
                isEnd: isEnd,
            },
            parentid,
            addIndex++
        );
    }
};
function clickoutSide(nameClass, callback) {
    // 全局注册点击事件
    document.onclick = function (e) {
        //若点击元素为目标元素则返回
        if (e.target.className != nameClass) return;
        //否则执行回调函数
        callback();
    };
};
/**
 *将wbs转成Number，用于排序
 *
 * @param {string} wbs  1.2.3
 * @return {Number}  1230000
 */
export function complement(wbs) {
    let array = wbs.split(".");
    let size = array.length;
    let n = 9;
    let ret = 0;
    for (let i = 0; i < size; i++) {
        let a = array[i];
        a = parseInt(a); a = a * Math.pow(10, n);
        ret += a; n -= 3;
    }
    return ret;
};
//-----------------------------------------------------------------------------------------------------------
export {
    getAutoCDMModel,
    getAutoCDMProjects,
    buildTasks,
    getGanttTasks,
    taskUtils,
    buildTasksTree,
    getChild,//从数组[root]中取到root和children的id
    getRemainComps,
    autoBuildTasks,//自动生成计划任务数据
    ramdomID,
    appendCompTasks,
    clickoutSide
};


// WEBPACK FOOTER //
// ./src/ref/autocdm/utils.js